import React from 'react';

// Friendly display labels for line types (the raw value is still used as the
// CSS class). Types without an entry fall back to the raw value.
const LINE_TYPE_LABELS = {
  speech: 'speech',
  embodied: 'embodied',
  gloss: 'gloss',
  translation: 'translation',
};

const AppStatusBar = ({ line, column, charCount, fileName, isModified, lineType, zoomLevel }) => {
  return (
    <div className="status-bar">
      <div className="status-info">
        <span>Ln {line}</span>
        <span>Col {column}</span>
        <span>{charCount} chars</span>
        {lineType && lineType !== 'default' && (
          <span className={`line-type-indicator ${lineType}`}>
            {LINE_TYPE_LABELS[lineType] || lineType}
          </span>
        )}
      </div>
      <div className="file-info">
        <span style={{ marginRight: 12 }}>{zoomLevel}%</span>
        {fileName}{isModified ? ' \u2022' : ''}
      </div>
    </div>
  );
};

export default AppStatusBar;
